import { Box, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useTranslation } from '../hooks/useTranslation';

const STAGE_CONFIG = {
  NONE: {
    labelKey: 'accessStage.NONE',
    tooltipKey: 'accessStage.noneTooltip',
    icon: LockOutlinedIcon,
    color: '#b0b0b0',
  },
  PENDING: {
    labelKey: 'accessStage.PENDING',
    tooltipKey: 'accessStage.pendingTooltip',
    icon: HourglassEmptyOutlinedIcon,
    color: '#f5a623',
  },
  APPROVED: {
    labelKey: 'accessStage.APPROVED',
    tooltipKey: 'accessStage.approvedTooltip',
    icon: CheckCircleOutlinedIcon,
    color: '#83d84d',
  },
  REJECTED: {
    labelKey: 'accessStage.REJECTED',
    tooltipKey: 'accessStage.rejectedTooltip',
    icon: CancelOutlinedIcon,
    color: '#f44336',
  },
};

export function AccessStageBadge({ stage }) {
  const { t } = useTranslation();

  const config = STAGE_CONFIG[stage] ?? STAGE_CONFIG.NONE;
  const Icon = config.icon;

  return (
    <Tooltip title={t(config.tooltipKey)} placement="bottom" arrow>
      <Box
        role="status"
        tabIndex={0}
        aria-label={t(config.tooltipKey)}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          px: '12px',
          py: '5px',
          borderRadius: '20px',
          border: `1px solid ${alpha(config.color, 0.35)}`, // CHANGED
          backgroundColor: alpha(config.color, 0.12),        // CHANGED
          cursor: 'default',
          userSelect: 'none',
          transition: 'all 0.2s',
          '&:focus-visible': {
            outline: `2px solid ${config.color}`,
            outlineOffset: '2px',
          },
        }}
      >
        <Icon sx={{ fontSize: 14, color: config.color }} />
        <Box
          component="span"
          sx={{
            fontSize: '11px',
            fontWeight: 600,
            color: config.color,
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            lineHeight: 1,
          }}
        >
          {t(config.labelKey)}
        </Box>
      </Box>
    </Tooltip>
  );
}
